var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.0000917 1c-6.07585003 0-11.0000917 4.92424167-11.0000917 11 0 6.0757583 4.92424167 11 11.0000917 11 6.0756666 0 10.9999083-4.9242417 10.9999083-11 0-6.07575833-4.9242417-11-10.9999083-11zm3.7109875 13.1554958c.4296875.4296875.4296875 1.1258042 0 1.5554917-.4299625.4299625-1.1258959.4295958-1.5554917 0l-2.1555875-2.1555875-2.1555875 2.1555875c-.4299625.4299625-1.12589583.4295958-1.55549167 0-.4296875-.4296875-.4296875-1.1258042 0-1.5554917l2.15558747-2.1555875-2.15558747-2.1554958c-.4296875-.4296875-.4296875-1.12580417 0-1.55549167s1.12580417-.4296875 1.55549167 0l2.1555875 2.15558747 2.1555875-2.15558747c.4296875-.4296875 1.1258042-.4296875 1.5554917 0s.4296875 1.12580417 0 1.55549167l-2.1555875 2.1554958z",
    fill: "#d54b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCross);
export default __webpack_public_path__ + "static/media/icon-circle-cross.b817de51.svg";
export { ForwardRef as ReactComponent };